import React, { useState } from 'react'; 
import MatchingProfileSurvey from 'components/containers/matching/survey/MatchingProfileSurvey';

import TitleHeader from 'components/presenters/header/TitleHeader';
export default function MatchingSurveyLayout() { 
  const [onBackBtn, setOnBackBtn] = useState(null);

  return (
    <>
      <div style={{height: 'calc(100vw*(51/375))'}}>
        <TitleHeader 
          onBackBtn={onBackBtn}
        />
      </div>
      <MatchingProfileSurvey setOnBackBtn={setOnBackBtn}/>
    </>
  );
}
